<template>
  <div class="node-branch-box">
    <custom-tree-node :index="0" class="node-father" :class="{'node-father-has':hasChild}" :firstIndex="firstIndex" :data="data" 
     :hasChild="hasChild"  @delete="onDelete"/>
    <!-- <custom-tree-node v-if="childData&&hasChild" class="node-child" :index="1" :firstIndex="childData.id" :data="childData" @change="onNodeChange" @delete="onDelete" @showChild="showChild"
      @childChange="childChange" :isSelect="true" :hasChild="true" :filterArr="filterArr">
    </custom-tree-node> -->
  </div>
</template>

<script>
import customTreeNode from './node';
import uniqueId from 'lodash/uniqueId';
import omit from 'lodash/omit';
export default {
  name: 'customSubTreeGroup',
  props: ['index', 'firstIndex', 'data'],
  data() {
    return {
      hasChild: false, //是否有子节点
    }
  },
  components: {
    customTreeNode
  },
  methods: {
    onDelete(index, firstIndex) {
      this.$emit('delete', this.index, this.firstIndex)
    },
  }
}
</script>

<style lang='scss'>
.node-branch-box {
  .node-father {
    &::before {
      content: "";
      display: block;
      width: 24px;
      height: 0px;
      position: absolute;
      top: 27px;
      left: 0px;
      border-bottom: 1px dashed #d9d9d9;
    }
  }
  .node-father-has {
    &::after {
      content: "";
      display: block;
      width: 0px;
      height: 100%;
      position: absolute;
      left: 48px;
      top: 28px;
      border-left: 1px dashed #d9d9d9;
    }
  }

  .node-child {
    &::before {
      content: "";
      display: block;
      width: 16px;
      height: 0px;
      position: absolute;
      top: 26px;
      left: 0px;
      border-bottom: 1px dashed #d9d9d9;
    }
  }
  .el-input--small{
              .el-input__icon{
                line-height: 36px;
             }
          }
}
</style>
<style lang='scss' scoped>
.node-branch-box {
  position: relative;
  &::before {
    content: "";
    display: block;
    position: absolute;
    height: 100%;
    width: 0px;
    border-left: 1px dashed #d9d9d9;
  }
  &:first-child {
    &::before {
      top: 26px;
    }
  }

  .node-father {
    &::before {
      content: "";
      display: block;
      width: 24px;
      height: 0px;
      position: absolute;
      top: 27px;
      left: 0px;
      border-bottom: 1px dashed #d9d9d9;
    }
  }
  .node-father-has {
    &::after {
      content: "";
      display: block;
      width: 0px;
      height: 100%;
      position: absolute;
      left: 48px;
      top: 28px;
      border-left: 1px dashed #d9d9d9;
    }
  }

  .node-child {
    &::before {
      content: "";
      display: block;
      width: 16px;
      height: 0px;
      position: absolute;
      top: 26px;
      left: 0px;
      border-bottom: 1px dashed #d9d9d9;
    }
  }
}

.node-child {
  padding-left: 62px !important;
  &::before {
    left: 48px !important;
  }
}
</style>
